import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage, blogIndexHead } from "@/pages/BlogIndexPage";

export const Route = createFileRoute("/en/articles/")({
  head: () => blogIndexHead("en"),
  component: () => <BlogIndexPage locale="en" />,
});
